import React from "react";
import "./users.scss";
const Users = ({ varient, users, show, toolTipText }) => {
  return (
    <div className={varient ? `users ${varient}` : "users"}>
      {users.slice(0, show).map((user) => (
        <div className="user" key={user.id}>
          <img src={user.imgUrl} alt={user.altText} />
          <div className="user_tooltips">
            {user.brabbler} {toolTipText}
          </div>
        </div>
      ))}
      {users.length > show ? (
        <div className="more_user">+{users.length - show}</div>
      ) : null}
    </div>
  );
};

export default Users;
